export default "__VITE_ASSET__BbWUfVEf__"